/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-escape */
import { Outcome, User } from "api/types";
import { Option } from "components/Select";
import { FormData, FormField } from "components/types";
import { handleGenericResponse } from "components/utility";
import { UseFormReturn } from "react-hook-form";
import { convertYesNoToBoolean, getChangedFields } from "../../utils/util";
import AdminUpdatePersonalDetails from "./admin/AdminUpdatePersonalDetails";
import { editClient } from "api/client";
import AdminContactDetails from "./admin/AdminContactDetails";
import AdminResidentialAddressAndMailingDetails from "./admin/AdminResidentialAddressAndMailingDetails";

export const options = [
  {
    label: Outcome.PASSED,
    value: Outcome.ACCEPTED,
  },
  {
    label: Outcome.FAILED,
    value: Outcome.REJECTED,
  },
];

export enum StepNames {
  "PERSONAL_DETAILS" = "PERSONAL_DETAILS",
  "CONTACT_DETAILS" = "CONTACT_DETAILS",
  "RESIDENTIAL_AND_MAILING_DETAILS" = "RESIDENTIAL_AND_MAILING_DETAILS",
}

export const StepnameToEndpoint = {
  PERSONAL_DETAILS: "/api/user/admin/client/section/personal-details",
  CONTACT_DETAILS: "/api/user/admin/client/section/contact-details",
};

export const FIELDS_TO_REMOVE = [
  "calendarMonth",
  "calendarYear",
  "confirmDetails",
  "legallyWorkInAustralia",
  "firstName",
  "lastName",
  "emailCheckForValidation",
  "sameAsResidentialAddress",
  "ownerName",
];

export const SUPER_ADMIN_FIELDS_TO_REMOVE = [
  "calendarMonth",
  "calendarYear",
  "confirmDetails",
  "legallyWorkInAustralia",
  "emailCheckForValidation",
  "sameAsResidentialAddress",
];

export const getFieldsToRemovePerStep = (
  stepName: StepNames,
  isSuperAdmin: boolean
) => {
  return isSuperAdmin ? SUPER_ADMIN_FIELDS_TO_REMOVE : FIELDS_TO_REMOVE;
};

export const useEditableForm = (
  user: User,
  stepName: StepNames | undefined,
  defaultFormMethods: UseFormReturn<FormData, any, undefined>,
  adminStaffOptions: Option[],
  handleCloseModal: () => void,
  isSuperAdmin = false
) => {
  if (!stepName) {
    return <h3>Please select a step to edit</h3>;
  }

  const { watch, ...formMethods } = defaultFormMethods;

  const onSubmit = async (data: FormData) => {
    const updatedFormData = convertYesNoToBoolean(data);
    const endpoint = StepnameToEndpoint[stepName as keyof typeof StepnameToEndpoint];
    const updatedField = getChangedFields(
      {
        ...user,
        ...user.clientProfile,
      },
      updatedFormData
    );

    const response = await editClient(
      `${endpoint}/${user.id}`,
      updatedField,
      getFieldsToRemovePerStep(stepName, isSuperAdmin)
    );

    const result = await handleGenericResponse(response);
    result && handleCloseModal();
  };

  switch (stepName) {
    case StepNames.PERSONAL_DETAILS as StepNames:
      return (
        <AdminUpdatePersonalDetails
          user={user}
          onSubmitFn={onSubmit}
          isSuperAdmin={isSuperAdmin}
        />
      );
    case StepNames.CONTACT_DETAILS as StepNames:
      return (
        <AdminContactDetails
          user={user}
          onSubmitFn={onSubmit}
          isSuperAdmin={isSuperAdmin}
        />
      );
    case StepNames.RESIDENTIAL_AND_MAILING_DETAILS as StepNames:
      return (
        <AdminResidentialAddressAndMailingDetails
          user={user}
          onSubmitFn={onSubmit}
          isSuperAdmin={isSuperAdmin}
        />
      );
    default:
      return (
        <div>Test Default</div>
      );
  }
};
